(function ($, Drupal) {

  // Footer behaviors (Toggle nav list)
  Drupal.behaviors.initFooterNewsletter = {
    attach: function (context, settings) {

      $('.js_footer', context).each(function () {

        let $el = $(this),
            $form = $el.find('.footer__newsletter ');

        $form.on('click', '.messages--success .close', function(evt) {
          $form.remove();
        });

      });
    }
  };

})(jQuery, Drupal);